export default {
    GOOGLE: 4,
    KW_CHANGE_ADD: 1,
    KW_CHANGE_REMOVE: 2,
    KW_CHANGE_RESTORED: 6,
    SYSTEM: 5,
    USER: 3,
    VOLATILITY: 0,
};
